export default {
  title: 'Utilisation du plafond global des avantages fiscaux',
  subtitle: 'Réductions et crédits soumis au plafond global utilisés',
  viewOptions: {
    niches: 'Utilisation des niches',
  },
  useNiches: 'Utilisation des plafonds',
  generalNiches: 'Plafond général',
  complementaryNiches: 'Plafond complémentaire',
  tooltip: {
    legend:
      "Montant du plafonnement des avantages fiscaux déjà utilisé par les dépenses et investissements donnant droit à réductions et crédits d'impôt réalisés pour l'exercice en cours.",
    generalNiches: 'Plafond général',
    complementaryNiches: 'Plafond complémentaire',
  },
}
